import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e5156e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RotationBlocker__Icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "RotationBlocker__Icon__Arrows",
  width: "41",
  height: "44",
  viewBox: "0 0 41 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3606_7252)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M28.4381 42.3127L31.8579 43.8927C32.1346 44.0204 32.4625 43.8998 32.5903 43.6231C32.718 43.3464 32.5973 43.019 32.3207 42.8907L30.04 41.8369C33.1867 41.0401 35.3616 39.7183 36.8406 38.2376C38.581 36.4995 39.3472 34.561 39.6741 33.0666C40.001 31.5696 39.8962 30.5092 39.8929 30.4688C39.8618 30.1659 39.5917 29.9449 39.2882 29.9755C39.1567 29.9886 39.0405 30.0475 38.9537 30.1343C38.8407 30.2473 38.7774 30.4088 38.7943 30.5802V30.584C38.802 30.6626 38.8757 31.6362 38.5668 32.958C38.2573 34.2809 37.5724 35.946 36.0602 37.4588C34.7269 38.7909 32.7409 40.0188 29.7437 40.7747L30.761 38.5246C30.8865 38.2468 30.7632 37.9199 30.4854 37.7944C30.2698 37.6973 30.0253 37.7496 29.8676 37.9074C29.8217 37.9532 29.7835 38.0078 29.7552 38.07L28.1671 41.5846C28.0426 41.8607 28.1638 42.1855 28.4383 42.3126L28.4381 42.3127Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip1_3606_7252)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.305 2.56326L9.88531 0.983269C9.60861 0.855565 9.28062 0.976175 9.15291 1.25287C9.02521 1.52957 9.14582 1.85701 9.42251 1.98526L11.7032 3.03911C8.55644 3.8359 6.38156 5.15769 4.90257 6.63835C3.16219 8.3765 2.39601 10.315 2.06909 11.8093C1.74219 13.3063 1.84697 14.3668 1.85024 14.4071C1.88135 14.71 2.15149 14.9311 2.45493 14.9005C2.58645 14.8874 2.70269 14.8285 2.78947 14.7417C2.90244 14.6287 2.96574 14.4672 2.94882 14.2958L2.94882 14.292C2.94118 14.2134 2.8675 13.2398 3.1764 11.918C3.48583 10.5951 4.17075 8.93001 5.68296 7.41722C7.01622 6.08504 9.00222 4.85715 11.9994 4.10131L10.9822 6.35136C10.8567 6.62915 10.98 6.95605 11.2578 7.08158C11.4734 7.17872 11.7179 7.12633 11.8756 6.96861C11.9214 6.92277 11.9596 6.86819 11.988 6.80597L13.5761 3.29139C13.7005 3.01524 13.5794 2.69052 13.3049 2.56337L13.305 2.56326Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3606_7252" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "13.9711",
        height: "13.9711",
        fill: "white",
        transform: "translate(27.0283 29.9727)"
      })
    ]),
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip1_3606_7252" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "13.9711",
        height: "13.9711",
        fill: "white",
        transform: "translate(14.7148 14.9033) rotate(-180)"
      })
    ])
  ])
], -1))
const _hoisted_3 = {
  class: "RotationBlocker__Icon__Phone",
  ref: "phone",
  width: "37",
  height: "37",
  viewBox: "0 0 37 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M22.6702 6.45264L13.3749 6.45264C11.761 6.45474 10.4532 7.86721 10.4512 9.61024L10.4512 27.2208C10.4531 28.9638 11.761 30.3762 13.3749 30.3784L22.6702 30.3784C24.284 30.3763 25.5919 28.9638 25.5939 27.2208L25.5939 9.61024C25.5919 7.86727 24.2841 6.45479 22.6702 6.45264ZM24.4243 27.2197V27.2208C24.4243 28.2669 23.6389 29.1153 22.6702 29.1153L13.3749 29.1153C12.4062 29.1153 11.6207 28.2669 11.6207 27.2208L11.6207 9.61022C11.6207 8.56402 12.4062 7.71571 13.3749 7.71571L22.6702 7.71571C23.6389 7.71571 24.4243 8.56402 24.4243 9.61022L24.4243 27.2197ZM19.768 9.15327C19.768 9.50166 19.5058 9.78479 19.1832 9.78479L16.8618 9.78479C16.5393 9.78479 16.2771 9.50166 16.2771 9.15327C16.2771 8.80488 16.5393 8.52174 16.8618 8.52174L19.1832 8.52174C19.5058 8.52174 19.768 8.80488 19.768 9.15327ZM21.262 9.03118C21.2698 9.07117 21.2737 9.11222 21.2737 9.15327C21.2737 9.23536 21.2581 9.31746 21.2269 9.39324C21.1996 9.47112 21.1567 9.54164 21.1021 9.59953C20.992 9.71741 20.8439 9.78372 20.6889 9.78477C20.6119 9.78477 20.535 9.76898 20.4628 9.73846C20.3927 9.70478 20.3293 9.65847 20.2757 9.59953C20.1646 9.4827 20.1023 9.3206 20.1042 9.15328C20.1042 9.11223 20.1081 9.07118 20.1159 9.03119C20.1198 8.99014 20.1305 8.95014 20.1471 8.91331C20.1627 8.87542 20.1812 8.83858 20.2017 8.80384C20.2231 8.76911 20.2484 8.73648 20.2757 8.70701C20.303 8.67754 20.3313 8.65123 20.3615 8.62702C20.3966 8.60597 20.4278 8.58492 20.4628 8.56808C20.4979 8.55124 20.5369 8.54282 20.572 8.5344C20.648 8.51756 20.726 8.51756 20.802 8.5344C20.839 8.54282 20.8751 8.5544 20.9111 8.56808C20.9462 8.58492 20.9803 8.60492 21.0125 8.62702C21.0437 8.65123 21.0739 8.67754 21.1021 8.70701C21.1294 8.73543 21.1528 8.76806 21.1723 8.80384C21.1947 8.83752 21.2123 8.87436 21.2269 8.91331C21.2425 8.95119 21.2542 8.99014 21.262 9.03119L21.262 9.03118ZM19.5312 27.6775C19.5312 28.0258 19.269 28.309 18.9464 28.309H17.0987C16.7761 28.309 16.5139 28.0258 16.5139 27.6775C16.5139 27.3291 16.7761 27.0459 17.0987 27.0459H18.9464C19.269 27.0459 19.5312 27.3291 19.5312 27.6775Z",
  fill: "white"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyPicture = _resolveComponent("LazyPicture")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["RotationBlocker", { 'is-touch': _ctx.isTouch }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5, 512))
      ]),
      _createElementVNode("h2", {
        innerHTML: _ctx.$t('blocker.title')
      }, null, 8, _hoisted_6),
      _createElementVNode("p", {
        innerHTML: _ctx.$t('blocker.description')
      }, null, 8, _hoisted_7),
      _createVNode(_component_LazyPicture, {
        class: "RotationBlocker__Bottle picture picture--appear",
        alt: _ctx.$t('blocker.title'),
        image: { url: '/images/blocker/blocker-bottle.png', double: {url: '/images/blocker/blocker-bottle@2x.png' } }
      }, null, 8, ["alt", "image"]),
      _createVNode(_component_LazyPicture, {
        class: "RotationBlocker__Tool picture picture--appear",
        alt: _ctx.$t('blocker.title'),
        image: { url: '/images/blocker/blocker-tool.png', double: {url: '/images/blocker/blocker-tool@2x.png' } }
      }, null, 8, ["alt", "image"])
    ], 2)
  ]))
}